module.exports = __webpack_public_path__ + "img/logo.e89ff4f3.png";